import _ from "lodash"
import { GTM_VIEW_RESERVATION } from "constant"
import { pushDataLayer } from "./pushDataLayer"
import { ImdfFeature } from "providers/venue/types"

export const gtmPushDataLayerViewReservation = (feature: ImdfFeature) => {
  const localCategoriesName = _.map(
    feature?.properties?.local_categories,
    (taxonomy) => _.get(taxonomy, "properties.name.en")
  ).join(",")
  pushDataLayer({
    event: GTM_VIEW_RESERVATION,
    feature_id: _.get(feature, "id"),
    feature_type: _.get(feature, "feature_type"),
    feature_name: _.get(feature, "properties.name.en"),
    feature_category: _.get(feature, "properties.category"),
    local_categories: localCategoriesName,
  })
}
